// HorizontalBarTooltipContent.jsx
import React from 'react';
import { ColumnFlexBox } from '../../../../../../../Components/FlexBox';
import { Typography } from '@mui/material';
import { formatThousands } from '../../../../../../../Utils/constants/general';

const TooltipContent = function TooltipContent({ data, total = 0 }) {
  if (!data) return null;

  return (
    <ColumnFlexBox gap="8px" padding="8px" minWidth="150px">
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: '#fff', // Assuming dark tooltip background
          fontSize: '1rem',
        }}
      >
        {data.label}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: 'center',
          color: data.color, // Uses the specific segment's color
          fontWeight: 'bold',
          fontSize: '1.5rem',
        }}
      >
        {Math.round((data.value / total) * 100)}%
      </Typography>
    </ColumnFlexBox>
  );
};

export default TooltipContent;
